import { SET_CREATE_MAP_PINCODE_WITH_HFR, SET_GEOMETRY_MAP_POINT, SET_MAP_LAT_LONG, SET_MAP_MANUAL_ADDRESS, SET_MAP_MANUAL_LAT_LONG, SET_MAP_MANUAL_LAT_LONG_CLICKED, SET_MAP_PINCODE_FIRST_TIME_EDIT, SET_MAP_SERVICES_CREATE_POLYGON, SET_MAP_SERVICES_DOWN, SET_MAP_SERVICES_POLYGON_FOR_EDIT } from "@store/types/facilityGeoMapTypes";

export const setGeometryMapPoint = (data: any) => {
  return {
    type: SET_GEOMETRY_MAP_POINT,
    payload: data
  };
};

export const setMapManualAddress = (data: any) => {
  return {
    type: SET_MAP_MANUAL_ADDRESS,
    payload: data
  };
};

export const setMapLatLong = (data: any) => {
  return {
    type: SET_MAP_LAT_LONG,
    payload: data
  };
};

export const setMapManualLatLong = (data: any) => {
  return {
    type: SET_MAP_MANUAL_LAT_LONG,
    payload: data
  }
};

export const setMapManualLatLongClicked = (data: any) => {
  return {
    type: SET_MAP_MANUAL_LAT_LONG_CLICKED,
    payload: data
  }
};

export const setMapPincodeFirstTimeEdit = (data: any) => {
  return {
    type: SET_MAP_PINCODE_FIRST_TIME_EDIT,
    payload: data
  }
};

export const setCreateMapPincodeWithHfr = (data: any) => {
  return {
    type: SET_CREATE_MAP_PINCODE_WITH_HFR,
    payload: data
  }
};

export const setMapServicesDown = (data: any) => {
  return {
    type: SET_MAP_SERVICES_DOWN,
    payload: data
  }
};

export const setMapServicesCreatePolygon = (data: any) => {
  return {
    type: SET_MAP_SERVICES_CREATE_POLYGON,
    payload: data
  }
};

export const setMapServicesPolygonForEdit = (data: any) => {
  return {
    type: SET_MAP_SERVICES_POLYGON_FOR_EDIT,
    payload: data
  }
};